export default "__VITE_ASSET__B5l_Gf3d__"